"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rPetPricingAndAnalytics = void 0;
const rPetPricingAndAnalytics = exports.rPetPricingAndAnalytics = {
  'R-PET_PRICING_AND_ANALYTICS': {
    en: {
      title: 'R-PET pricing and analytics',
      subtitle: 'Optimise trading in this vital and fast-growing market',
      description: 'Gain a clear view of fast-moving R-PET markets with reliable pricing and market insight from the recognised price benchmark.',
      list: ['Monthly and 3-month forecasts for bales, flake and food-grade pellets', 'Coverage of all European R-PET grades, by colour and type, plus Asia and the US', 'Up-to-date market news and analysis', 'Historic European pricing data']
    },
    zh: {
      title: 'R-PET价格和分析',
      subtitle: '在这个重要且快速增长的市场中优化交易',
      description: '基于市场认可的价格基准，提供可靠的价格信息与市场洞察，助您清晰了解快速发展的R-PET市场。',
      list: ['瓶砖、瓶片和食品级颗粒的月度与三个月预测', '涵盖所有欧洲市场的R-PET级别，按颜色和类型分类，以及亚洲和美国', '最新市场资讯与分析', '欧洲历史价格数据']
    }
  }
};